import { RUNTIME_ENV } from '@bfe/by-env';
import Monitor from '@fe/monitor';

const environment = {
  dev: 'dev', // 开发
  test: 'sitnet', // 测试
  testnet: 'testnet', // 预发布
  prod: 'mainnet', // 生产
};

const monitor = new Monitor();
monitor.init(
  {
    env: environment[RUNTIME_ENV as keyof typeof environment] as any,
    release: '1.0.0',
    traceWhiteList: ['.api2', 'api2.', 'x-api'],
    onResponse: (data) => {
      if (typeof data.retCode === 'number') {
        return data.retCode;
      } else {
        return data.ret_code;
      }
    },
  },
  { p: 'user-service-fe' }, // ByLogger 业务标识,新业务字段是可选
);

export default {
  addEvent: (logger: any) => {
    monitor.log(logger);
  },
};
